import { Component, EventEmitter, Input, NgZone, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
	defaultDocumentSettingsDialogConfig,
	DocumentSettingsComponent,
} from '@components/documents-matter-editor/document-settings/document-settings.component';
import {
	BusinessDocumentV2,
	DocumentV2,
	DocumentV2Html,
	DocumentLocation,
	DocumentMargins,
	PageSize,
} from '@models/documents';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessDocumentHtmlRepoService } from '@repos/business-document-html/business-document-html.service';
import { BusinessState } from '@state/business';
import { cloneDeep } from 'lodash';
import { take } from 'rxjs/operators';

@Component({
	selector: 'app-business-document-editor',
	templateUrl: './business-document-editor.component.html',
	standalone: false,
})
export class BusinessDocumentEditorComponent {
	@Output() onDocumentTitleChange: EventEmitter<string> = new EventEmitter();
	@Output() onDocumentHtmlChange: EventEmitter<string> = new EventEmitter();
	@Output() onDocumentMarginsAndPageSizeChange: EventEmitter<{
		margins: DocumentMargins;
		pageSize: PageSize;
	}> = new EventEmitter();

	@Output() onDocumentChange: EventEmitter<DocumentV2> = new EventEmitter();

	@Input() set document(doc: BusinessDocumentV2) {
		this._document = cloneDeep(doc);
		this.defaultBusinessDocument = cloneDeep(doc);
	}

	@Input() set documentHtml(doc: DocumentV2Html) {
		this._documentHtml = doc;
	}

	@Input() disabled = false;

	_sourceId: string;
	_version: string;
	_documentHtml: DocumentV2Html;

	defaultBusinessDocument: DocumentV2;
	_document: BusinessDocumentV2;

	businessLocation = DocumentLocation.BUSINESS;

	get document() {
		return this._document;
	}
	@SelectSnapshot(BusinessState.getDefaultPageMargins)
	defaultPageMargins: DocumentMargins;
	@SelectSnapshot(BusinessState.getDefaultPageSize) defaultPageSize: PageSize;

	constructor(
		private businessDocumentHtmlRepoService: BusinessDocumentHtmlRepoService,
		private zone: NgZone,
		private dialog: MatDialog,
	) {}

	updateContent(html: string) {
		this._documentHtml.html = html;
		this.onDocumentHtmlChange.emit(html);
	}

	updateTitle(title: string) {
		this.document.title = title;
		this.onDocumentTitleChange.emit(title);
	}

	statusChange(event) {}

	toggleDocumentSettings() {
		this.zone.run(() => {
			this.dialog
				.open(DocumentSettingsComponent, {
					...defaultDocumentSettingsDialogConfig,
					data: {
						defaultMargins: this.defaultPageMargins,
						defaultPageSize: this.defaultPageSize,
						margins:
							this.document.margins ||
							this.defaultBusinessDocument.margins ||
							this.defaultPageMargins,
						pageSize:
							this.document.pageSize ||
							this.defaultBusinessDocument.pageSize ||
							this.defaultPageSize,
					},
				})
				.afterClosed()
				.pipe(take(1))
				.subscribe((value: BusinessDocumentV2) => {
					if (value) {
						this.document = {
							...this.document,
							margins: value.margins,
							pageSize: value.pageSize,
						};
						this.onDocumentMarginsAndPageSizeChange.emit({
							margins: value.margins,
							pageSize: value.pageSize,
						});
					}
				});
		});
	}
}
